import { BUILD_PRODUCT } from 'gatsby-env-variables'

const getProduct = () => BUILD_PRODUCT

export default getProduct
